/* LINO B2B / B2C – deferred behaviours (mode is already resolved by snippets/lino-mode.liquid in <head>) */
(function () {
  'use strict';
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }
  ready(function () {
    var L = window.LinoMode || { mode: 'b2b', page: 'auto', home: { b2b: '/pages/for-business', b2c: '/pages/for-you' } };
    var mode = L.mode;
    var isB2C = mode === 'b2c';

    /* 1. Logo / "home" links follow the current world */
    document.querySelectorAll('[data-lino-home]').forEach(function (a) {
      var target = isB2C ? (a.getAttribute('data-lino-home-b2c') || L.home.b2c) : (a.getAttribute('data-lino-home-b2b') || L.home.b2b);
      if (target) { a.setAttribute('href', target); }
    });

    /* 2. Any element with data-lino-set-mode="b2b|b2c" saves the choice on click (splash buttons, switch links) */
    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('[data-lino-set-mode]');
      if (!el) return;
      var m = el.getAttribute('data-lino-set-mode');
      if (L.set) { L.set(m); }
    }, true);

    /* 3. Consumer search: restrict results to products tagged B2C (needs the "Tag" filter enabled in Search & Discovery) */
    if (isB2C && L.searchFilter) {
      document.querySelectorAll('input.lino-search-b2c-filter').forEach(function (i) { i.disabled = false; });
    }

    /* 4. Trade mode safety net: nothing can be added to the cart, even if some mark-up slipped through */
    if (!isB2C) {
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (f && f.matches && f.matches('form[action^="/cart/add"], form.product-form')) {
          e.preventDefault(); e.stopImmediatePropagation();
          if (window.console) { console.warn('[Lino] Cart is disabled in B2B mode.'); }
        }
      }, true);
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('button[name="add"], button[name="add-to-cart"], .js-grid-cart, .lino-add-to-cart, .shopify-payment-button, #js-sticky-btn');
        if (b) { e.preventDefault(); e.stopImmediatePropagation(); }
      }, true);
    }

    /* 5. Mobile drawer: the FOR YOU menu and the world switch chosen in the Header section are rendered into
          <template id="LinoDrawerExtras"> (sections/header.liquid) and moved here into #NavDrawer, so the header
          settings drive mobile too. Re-run on theme-editor section reloads. */
    function applyDrawerExtras() {
      var tpl = document.getElementById('LinoDrawerExtras');
      var drawer = document.getElementById('NavDrawer');
      if (!tpl || !drawer || !tpl.content) return;
      var inner = drawer.querySelector('.drawer__inner') || drawer;
      var menu = tpl.content.querySelector('[data-lino-drawer-b2c]');
      if (menu) {
        var clone = menu.cloneNode(true);
        var current = drawer.querySelector('[data-lino-drawer-b2c]');
        if (current) { current.parentNode.replaceChild(clone, current); }
        else {
          var b2bList = drawer.querySelector('ul.drawer__nav.lino-b2b-only');
          if (b2bList && b2bList.parentNode) { b2bList.parentNode.insertBefore(clone, b2bList.nextSibling); }
          else { inner.insertBefore(clone, inner.firstChild); }
        }
      }
      var sw = tpl.content.querySelector('[data-lino-drawer-switch]');
      var currentSw = drawer.querySelector('[data-lino-drawer-switch]');
      if (sw) {
        var swClone = sw.cloneNode(true);
        if (currentSw) { currentSw.parentNode.replaceChild(swClone, currentSw); }
        else {
          var foot = drawer.querySelector('ul.menu-mobile-footer');
          if (foot) { foot.insertBefore(swClone, foot.firstChild); }
        }
      } else if (currentSw) {
        currentSw.parentNode.removeChild(currentSw);
      }
    }
    applyDrawerExtras();
    document.addEventListener('shopify:section:load', applyDrawerExtras);

    /* 6. Body helper class for CSS hooks in sections */
    document.body.classList.add('lino-mode-' + (L.page === 'splash' ? 'splash' : mode));
  });
})();
